// extracted by mini-css-extract-plugin
export default {"container":"hawk-grid-item-main-container"};